import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SpinnerService} from './services/spinner.service';
import {Subscription} from 'rxjs';
import {AuthService} from './services/auth.service';
import {isUndefined} from 'util';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {TransparentSpinnerService} from './services/transparent-spinner.service';
import {environment} from '../environments/environment';
import {PaginationComponent} from "./ui/pagination/pagination.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy, OnInit, AfterViewInit {

  private _subscriptions: Subscription[] = [];
  private _state: boolean;
  private _transParentSpinnerState: boolean;
  private _auth: boolean;

  @ViewChild('mainContainer', {static: false}) mainContainer: ElementRef;

  constructor(public spinnerInstance: SpinnerService,
              public transparentSpinnerService: TransparentSpinnerService,
              public authInstance: AuthService,
              public router: Router,
              private activatedRoute: ActivatedRoute) {

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.mainContainer.nativeElement.scrollTo(0, 0);
      }
    });
    try {
      console.log(window.self !== window.top);
    } catch (e) {

    }
    const sub = this.spinnerInstance.status().subscribe(
      state => {
      this.state = state;
      }
    );
    const sub2 = this.authInstance.status().subscribe(
      state => {
      this.auth = state;
      }
    );
    const sub3 = this.transparentSpinnerService.status().subscribe(
      state => {
      this.transParentSpinnerState = state;
      }
    );
    this._subscriptions.push(sub);
    this._subscriptions.push(sub2);
    this._subscriptions.push(sub3);
    this._checkToken();
  }

  public logout() {
    localStorage.clear();
    this.authInstance.hide();
    this.router.navigate(['/']);
  }

  public checkEnvironment() {
    return environment.name;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  private _checkToken(): void {
    const token = localStorage.getItem('token');
    if (!isUndefined(token) && token !== null) {
      this.authInstance.show();
    } else {
      this.authInstance.hide();
    }
  }

  get transParentSpinnerState(): boolean {
    return this._transParentSpinnerState;
  }

  set transParentSpinnerState(value: boolean) {
    this._transParentSpinnerState = value;
  }


  get auth(): boolean {
    return this._auth;
  }

  set auth(value: boolean) {
    this._auth = value;
  }

  get state(): boolean {
    return this._state;
  }

  set state(value: boolean) {
    this._state = value;
  }

  ngOnDestroy() {
    for (let i = 0; this._subscriptions.length; i++) {
      this._subscriptions[i].unsubscribe();
    }
  }

}
